import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Public_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"variable\",\"display\":\"swap\",\"fallback\":[\"sans-serif\"],\"variable\":\"--Public_Sans\"}],\"variableName\":\"publicSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomOrgWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/customOrgContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/envContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/langContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrgWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/orgContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/resourceContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/style/global.scss");
